import type { MasteryLevel } from '@/types/user-data.js'

export const REVIEW_INTERVAL_DAYS: Record<Exclude<MasteryLevel, 0>, number> = {
  1: 1,
  2: 3,
  3: 7,
  4: 15,
}

export const MASTERY_FEEDBACK = [
  { level: 1 as const, label: '完全不会', shortLabel: '陌生' },
  { level: 2 as const, label: '有点印象', shortLabel: '有印象' },
  { level: 3 as const, label: '基本掌握', shortLabel: '基本掌握' },
  { level: 4 as const, label: '非常熟悉', shortLabel: '熟练掌握' },
]

export function scheduleNextReview(
  masteryLevel: Exclude<MasteryLevel, 0>,
  from: Date = new Date(),
): string {
  const days = REVIEW_INTERVAL_DAYS[masteryLevel]
  return new Date(from.getTime() + days * 24 * 60 * 60 * 1000).toISOString()
}

export function isReviewDue(nextReviewAt: string | undefined, now: Date = new Date()): boolean {
  if (!nextReviewAt) return false
  const timestamp = Date.parse(nextReviewAt)
  return Number.isFinite(timestamp) && timestamp <= now.getTime()
}

export function dateKey(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function daysBetween(left: Date, right: Date): number {
  const leftDay = Date.UTC(left.getFullYear(), left.getMonth(), left.getDate())
  const rightDay = Date.UTC(right.getFullYear(), right.getMonth(), right.getDate())
  return Math.round((leftDay - rightDay) / (24 * 60 * 60 * 1000))
}
